import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../services/spinner.service';
import { DocumentsService } from '../services/documents.service';
import { ActivatedRoute } from '@angular/router';
import { TopicsService } from '../services/topics.service';
import { Document } from '../models/document.model';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {
  public documentsList: Array<Document>;
  public name: string;
  private id: number;
  private sub: any;

  constructor(
    private route: ActivatedRoute,
    private documentService: DocumentsService,
    private spinnerService: SpinnerService,
    private topicsService: TopicsService
  ) {}

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['idTopico'];
      this.getByTopic(this.id);
      this.getTopic(this.id);
    });
  }

  public getAllDocuments() {
    this.spinnerService.updatedState(true);
    this.documentService.getAll().subscribe(
      (data: any) => {
        this.documentsList = new Array<Document>();
        Object.assign(this.documentsList, data);
        this.spinnerService.updatedState(false);
      },
      (err) => {
        console.log(err);
        this.spinnerService.updatedState(false);
      }
    );
  }

  public getByTopic(topicoId: number) {
    this.spinnerService.updatedState(true);
    this.documentService.getByTopic(topicoId).subscribe(
      (data: any) => {
        this.documentsList = new Array<Document>();
        Object.assign(this.documentsList, data);
        this.spinnerService.updatedState(false);
      },
      (err) => {
        console.log(err);
        this.spinnerService.updatedState(false);
      }
    );
  }

  public getTopic(topicoId: number) {
    this.topicsService.getById(topicoId).subscribe(
      (data: any) => {
        this.name = data ? data.Title : '';
      },
      (err) => {
        console.log(err);
      }
    );
  }

  public isEmpty() {
    return this.documentsList ? (this.documentsList.length == 0) : false;
  }
}
